import LooknumBox from '@/components/lookNumBox' // 数据展示
import DataForm from '@/components/dataForm' // 数据提交
export default (Vue) => {
  Vue.component('LooknumBox', LooknumBox)
  Vue.component('DataForm', DataForm)
}



// WEBPACK FOOTER //
// ./src/common/js/components.js